import { render, staticRenderFns } from "./Caret.vue?vue&type=template&id=45560e22&scoped=true&"
import script from "./Caret.vue?vue&type=script&lang=js&"
export * from "./Caret.vue?vue&type=script&lang=js&"
import style0 from "./Caret.vue?vue&type=style&index=0&id=45560e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45560e22",
  null
  
)

export default component.exports